import dayjs, { Dayjs } from 'dayjs'
import {
  BreakDetail,
  transformBreakDetailOnGet,
  transformBreakDetailOnSave,
} from './breakDetail'
import {
  ClockinRuleDetail,
  transformClockinRuleDetailOnGet,
  transformClockinRuleDetailOnSave,
} from './clockinRuleDetail'
import { Nullable } from '../types'

export interface RosteredShift {
  id: string
  adjustedHourlyRate: number
  clockinTime: Dayjs
  clockoutTime: Dayjs
  hourlyRate?: number | null
  breaks: BreakDetail[]
  jobs: string | null
  roleId: string
  roleName: string
  rules: ClockinRuleDetail[]
  staffMemberId: string
  staffMemberFirstName: string
  staffMemberLastName: string
  staffMemberDatestampDeleted: Nullable<Dayjs>
  rosterId: string
  datestampModified: Nullable<Dayjs>
  datestampCreated: Nullable<Dayjs>
  datestampDeleted: Nullable<Dayjs>
}

// Functions to apply transformations to RosteredShift object
export const transformRosteredShiftOnGet = (
  rosteredShift: RosteredShift
): RosteredShift => {
  return {
    ...rosteredShift,
    clockinTime: dayjs(rosteredShift.clockinTime),
    clockoutTime: dayjs(rosteredShift.clockoutTime),
    breaks: rosteredShift.breaks.map(transformBreakDetailOnGet),
    rules: rosteredShift.rules.map(transformClockinRuleDetailOnGet),
    datestampModified: rosteredShift.datestampModified
      ? dayjs(rosteredShift.datestampModified)
      : null,
    datestampCreated: rosteredShift.datestampCreated
      ? dayjs(rosteredShift.datestampCreated)
      : null,
    datestampDeleted: rosteredShift.datestampDeleted
      ? dayjs(rosteredShift.datestampDeleted)
      : null,
    staffMemberDatestampDeleted: rosteredShift.staffMemberDatestampDeleted
      ? dayjs(rosteredShift.staffMemberDatestampDeleted)
      : null,
  }
}

export const transformRosteredShiftOnSave = (
  rosteredShift: RosteredShift
): object => {
  return {
    ...rosteredShift,
    clockinTime: rosteredShift.clockinTime.utc(),
    clockoutTime: rosteredShift.clockoutTime.utc(),
    breaks: rosteredShift.breaks.map(transformBreakDetailOnSave),
    rules: rosteredShift.rules.map(transformClockinRuleDetailOnSave),
    datestampModified: rosteredShift.datestampModified
      ? dayjs(rosteredShift.datestampModified).utc()
      : null,
    datestampCreated: rosteredShift.datestampCreated
      ? dayjs(rosteredShift.datestampCreated).utc()
      : null,
    datestampDeleted: rosteredShift.datestampDeleted
      ? dayjs(rosteredShift.datestampDeleted).utc()
      : null,
    staffMemberDatestampDeleted: rosteredShift.staffMemberDatestampDeleted
      ? dayjs(rosteredShift.staffMemberDatestampDeleted).utc()
      : null,
  }
}
